import * as io from "io-ts";
import { BlockImport, BlockModel } from ".";
import { withMessage } from "io-ts-types";
import t from "../../../../../i18n";

export const BlockHeadingKind = withMessage(io.strict({ kind: io.literal("HEADING") }), () =>
  t("schema.block.kind"),
);

export const BlockHeadingData = io.type({ data: io.string });

export const BlockHeadingConfig = io.type({
  config: io.type({
    /** @description Heading level, can only be h2 or h3 */
    level: io.refinement(io.number, n => [2, 3, 4].includes(n)),
  }),
});

export const BlockHeadingModel = io.intersection([
  BlockModel,
  BlockHeadingKind,
  BlockHeadingData,
  BlockHeadingConfig,
]);

export const BlockHeadingImport = io.intersection([
  BlockImport,
  BlockHeadingKind,
  BlockHeadingData,
  BlockHeadingConfig,
]);

export type BlockHeadingModelT = io.TypeOf<typeof BlockHeadingModel>;
export type BlockHeadingImportT = io.TypeOf<typeof BlockHeadingImport>;
